export const MOBILE_MAX_WIDTH = 640;

export function getParameterCaseInsensitive(object, key) {
  return object[Object.keys(object)
    .find(k => k.toLowerCase() === key.toLowerCase())
  ];
}

export const isMobile = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;

export const isStaging = NODE_ENV === 'staging'; // eslint-disable-line